import { ProjectModel } from 'model/ProjectModel'
import {
  AssemblyDto,
  RowDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemExportedToErpSelector =
  (bomItemId: string) => (state: RootAppState) => {
    let bomItem: ProjectModel | AssemblyDto | RowDto
    if (bomItemId === state.project?.activeProject?.id) {
      bomItem = state.project.activeProject
    } else {
      bomItem = bomItemSelector(state, bomItemId)
    }

    return {
      isExported: bomItem.isExportedToErp,
      exportedResult: bomItem.exportedToErpResult,
      exportedStatus: bomItem.exportedToErpStatus,
    }
  }
